import React from "react";

const MoneyDateIcon = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        >
        <path
            opacity="0.2"
            d="M2.8125 6.1875H15.1875V3.375C15.1875 3.22582 15.1282 3.08274 15.0227 2.97725C14.9173 2.87176 14.7742 2.8125 14.625 2.8125H3.375C3.22582 2.8125 3.08274 2.87176 2.97725 2.97725C2.87176 3.08274 2.8125 3.22582 2.8125 3.375V6.1875Z"
            fill="#3B425F"
        />
        <path
            d="M14.625 2.8125H3.375C3.06434 2.8125 2.8125 3.06434 2.8125 3.375V14.625C2.8125 14.9357 3.06434 15.1875 3.375 15.1875H14.625C14.9357 15.1875 15.1875 14.9357 15.1875 14.625V3.375C15.1875 3.06434 14.9357 2.8125 14.625 2.8125Z"
            stroke="#3B425F"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.375 1.6875V3.9375"
            stroke="#3B425F"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.625 1.6875V3.9375"
            stroke="#3B425F"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.8125 6.1875H15.1875"
            stroke="#3B425F"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        </svg>
);

export default MoneyDateIcon;
